import { LitElement, html, css, unsafeCSS, svg } from 'lit';
import styles from './icon.scss?inline';
import { SIZES } from '../constants';
import { styleMap } from 'lit/directives/style-map.js';

export default class SotbitIcon extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        icon: { type: String },
        rotate: { type: String },
        size: {
            type: String,
            hasChanged(newVal, oldVal) {
                const isChange = newVal !== oldVal;

                if (!isChange || !newVal) {
                    return false;
                }

                if (!Number.isNaN(parseInt(newVal, 10))) {
                    return true;
                }

                return Object.hasOwn(SIZES, newVal.toUpperCase());
            },
        },
    };

    constructor() {
        super();
        const rawUrl = import.meta.url;
        const distBaseUrl = rawUrl.replace(/ui\/custom\/dist.*$/, 'ui/custom/dist').replace(/ui\/dist.*$/, 'ui/dist');

        const isCustom = rawUrl.includes('custom');
        let modules = null;

        if (isCustom) {
            modules = import.meta.glob('@/../custom/dist/assets/sotbit-icons.*.svg', {
                import: 'default',
                eager: false,
            });
        } else {
            modules = import.meta.glob('@/../dist/assets/sotbit-icons.*.svg', {
                import: 'default',
                eager: false,
            });
        }

        const fileName = Object.keys(modules)
            .find((el) => {
                return el.includes('sotbit-icons');
            })
            ?.match(/[^/]+\.[^/]+$/)[0];

        this.spriteUrl = new URL(`${distBaseUrl}/assets/${fileName}`).href;
        this.icon = null;
        this.rotate = null;
    }

    _getSizeValue() {
        if (!Number.isNaN(parseInt(this.size, 10))) {
            return this.size;
        }

        return SIZES[this.size?.toUpperCase()] || SIZES.M;
    }

    render() {
        const transform = this.rotate ? { transform: `rotate(${this.rotate}deg)` } : {};
        const style = {
            width: `var(--sotbit-icon-custom-width, ${this._getSizeValue()}px)`,
            height: `var(--sotbit-icon-custom-width, ${this._getSizeValue()}px)`,
            ...transform,
        };
        return html` <div class="wrapper" part="wrapper">
            <div part="background" class="background"></div>
            ${svg`
                    <svg style=${styleMap(style)}
                         class="icon"
                         part="icon"
                     >
                         <use href="${this.spriteUrl}#${this.icon}"></use>
                    </svg>
                `}
        </div>`;
    }
}
